<h1 style="color:#e7bd42">Prenota una prova gratuita</h1>

<!--VERSIONE A DUE COLONNE SU SCHERMO GRANDE-->
<!-- <div class="layout horizontal center top" style="width: 100%; flex-wrap: wrap;">
    <div style="margin: 0 20px" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%',
                                            'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
        <app-form-field label="Nome"
            [value]="valuesForInput.firstName"
            [settings]="settings.fieldsSettings.firstName"
            (modelChange)="updateCurrentValue('firstName',$event)"
            [specifiedAttributes]="specifiedAttributes.firstName">
        </app-form-field>
    </div>
    <div style="margin: 0 20px" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%',
                                            'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
        <app-form-field label="Cognome"
            [value]="valuesForInput.lastName"
            [settings]="settings.fieldsSettings.lastName"
            (modelChange)="updateCurrentValue('lastName',$event)"
            [specifiedAttributes]="specifiedAttributes.lastName">
        </app-form-field>
    </div>
</div>
<div class="layout horizontal center top" style="width: 100%; flex-wrap: wrap;">
    <div style="margin: 0 20px" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%',
                                            'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
        <app-form-field label="Email"
            type="EMAIL"
            [value]="valuesForInput.email"
            [settings]="settings.fieldsSettings.email"
            (modelChange)="updateCurrentValue('email',$event)"
            [specifiedAttributes]="specifiedAttributes.email">
        </app-form-field>
    </div>
    <div style="margin: 0 20px" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%',
                                            'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
        <app-form-field label="Cellulare"
            [value]="valuesForInput.mobileNumber"
            [settings]="settings.fieldsSettings.mobileNumber"
            (modelChange)="updateCurrentValue('mobileNumber',$event)"
            [specifiedAttributes]="specifiedAttributes.mobileNumber">
        </app-form-field>
    </div>
</div>
<div class="layout horizontal top" style="margin-top: 6px;"
     [ngClass]="{'right': canvasLayoutDataService.viewportWidth >= 1200 ? false : true,
                 'center': canvasLayoutDataService.viewportWidth >= 1200 ? true : false}"
     [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '100%' : '100%'}">
    <div class="layout horizontal top end" 
         [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '1044px' : '500px'}">
        <app-button label="INVIA" primary="true" [settings]="{padding: '8px 50px'}" [action]="submit.bind(this)" [disabled]="someErrors || formSubmitting"></app-button>
    </div>
</div> -->

<div class="layout vertical center top" style="width: 100%; flex-wrap: wrap;">
    <div style="margin: 0 20px" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%',
                                            'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
        <app-form-field label="Nome"
            [value]="valuesForInput.firstName"
            [settings]="settings.fieldsSettings.firstName"
            (modelChange)="updateCurrentValue('firstName',$event)"
            [specifiedAttributes]="specifiedAttributes.firstName">
        </app-form-field>
        <app-form-field label="Cognome"
            [value]="valuesForInput.lastName"
            [settings]="settings.fieldsSettings.lastName"
            (modelChange)="updateCurrentValue('lastName',$event)"
            [specifiedAttributes]="specifiedAttributes.lastName">
        </app-form-field>
        <app-form-field label="Email"
            type="EMAIL"
            [value]="valuesForInput.email"
            [settings]="settings.fieldsSettings.email"
            (modelChange)="updateCurrentValue('email',$event)"
            [specifiedAttributes]="specifiedAttributes.email">
        </app-form-field>
        <app-form-field label="Cellulare"
            [value]="valuesForInput.mobileNumber"
            [settings]="settings.fieldsSettings.mobileNumber"
            (modelChange)="updateCurrentValue('mobileNumber',$event)"
            [specifiedAttributes]="specifiedAttributes.mobileNumber">
        </app-form-field>
        <app-form-field
            label="Acconsento al trattamento dei miei dati personali per comunicazioni commerciali e informative, ai sensi dell'articolo 13 del Regolamento UE 2016/679*"
            type="ACKNOWLEDGEMENT_CHECKBOX"
            [value]="valuesForInput.privacy"
            [settings]="settings.fieldsSettings.privacy"
            (modelChange)="updateCurrentValue('privacy',$event)"
            [specifiedAttributes]="specifiedAttributes.privacy">
        </app-form-field>
    </div> 
    
    <div class="layout horizontal top right" style="margin-top: 12px;" [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '100%'}">
        <app-button label="INVIA" primary="true" [settings]="{padding: '8px 50px'}" [action]="submit.bind(this)" [disabled]="someErrors || formSubmitting"></app-button>
    </div>
</div>




<!-- <div class="layout horizontal top right" style="margin-top: 6px;">
    <div class="layout horizontal top end" 
         [ngStyle]="{'width': canvasLayoutDataService.viewportWidth >= 1200 ? '500px' : '500px'}">
        <app-button label="INVIA" primary="true" [settings]="{padding: '8px 50px'}" [action]="submit.bind(this)" [disabled]="someErrors || formSubmitting"></app-button>
    </div>
</div> -->


<!-- <div style="margin: 0 20px" [ngStyle]="{'width': '1000px',
    'margin': canvasLayoutDataService.viewportWidth >= 1200 ? '0 20px' : '0'}">
    <app-form-field
                label="Acconsento al trattamento dei miei dati personali per comunicazioni commerciali e informative, ai sensi dell'articolo 13 del Regolamento UE 2016/679*"
                type="CHECKBOX"
                [value]="valuesForInput.privacy"
                [settings]="settings.fieldsSettings.privacy"
                (modelChange)="updateCurrentValue('privacy',$event)"
                [specifiedAttributes]="specifiedAttributes.privacy">
    </app-form-field>
</div> -->